export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M19.05 4.95C21 6.9 22 9.25 22 12s-1 5.1-2.95 7.05S14.75 22 12 22s-5.1-1-7.05-2.95S2 14.75 2 12s1-5.1 2.95-7.05S9.25 2 12 2s5.1 1 7.05 2.95m-2.69 5.32H13V4l-5 9.73h3.5V20z\"/>"
};